import { PublishedFormId } from '@furnish-hx/constants/FormId';
import FormTypeId from '@core/constants/FormTypeId';
import fieldPortfolioData from './common/fieldsPortfolioData';
import {
    IFormFieldKey,
    IForm,
} from '../../interfaces/Form';
import fieldsContact from './common/fieldsContact';
import { IDesignProjectId, IDesignProjectCategoryId } from '../../interfaces/DesignProject';
import additionalDataFactory from './common/fieldsAdditionalData';
import budgetMarksBuilder from './common/budgetMarksBuilder';

const dpBeautyInstituteForm: IForm = {
    formId       : PublishedFormId.DpBeautyInstitute,
    type         : FormTypeId.DesignProject,
    thumbnailURL : '/resized-images/forms/dpBeautyInstitute.jpg',
    fieldsOrder  : [
        IFormFieldKey.PortfolioData,
        IFormFieldKey.Comment,
        IFormFieldKey.DesignProject,
        IFormFieldKey.AdditionalData,
        IFormFieldKey.Contact,
    ],
    fields: {
        portfolioData : fieldPortfolioData,
        comment       : {
            comment: {
                value    : undefined,
                required : false,
            },
        },
        designProject: {
            [IDesignProjectCategoryId.ShopFurniture]: {
                [IDesignProjectId.ReceptionDesk]: {
                    value : undefined,
                    min   : 0,
                    max   : 10,
                },
                [IDesignProjectId.CounterRight]: {
                    value : undefined,
                    min   : 0,
                    max   : 10,
                },
                [IDesignProjectId.CornerCounter]: {
                    value : undefined,
                    min   : 0,
                    max   : 10,
                },
                [IDesignProjectId.ShowCase]: {
                    value : undefined,
                    min   : 0,
                    max   : 5,
                },
                [IDesignProjectId.StorageUnit]: {
                    value : undefined,
                    min   : 0,
                    max   : 50,
                },
                [IDesignProjectId.Shelving]: {
                    value : undefined,
                    min   : 0,
                    max   : 50,
                },
                [IDesignProjectId.Sideboard]: {
                    value : undefined,
                    min   : 0,
                    max   : 20,
                },
                [IDesignProjectId.MetalCabinet]: {
                    value : undefined,
                    min   : 0,
                    max   : 20,
                },
                [IDesignProjectId.WoodenWardrobe]: {
                    value : undefined,
                    min   : 0,
                    max   : 20,
                },
                [IDesignProjectId.TreatmentTable]: {
                    value : undefined,
                    min   : 0,
                    max   : 20,
                },
                [IDesignProjectId.ManicureTable]: {
                    value : undefined,
                    min   : 0,
                    max   : 20,
                },
                [IDesignProjectId.PresentationTable]: {
                    value : undefined,
                    min   : 0,
                    max   : 20,
                },
            },
            [IDesignProjectCategoryId.Seated]: {
                [IDesignProjectId.Chair]: {
                    value : undefined,
                    min   : 0,
                    max   : 50,
                },
                [IDesignProjectId.Armchair]: {
                    value : undefined,
                    min   : 0,
                    max   : 50,
                },
                [IDesignProjectId.Stool]: {
                    value : undefined,
                    min   : 0,
                    max   : 50,
                },
                [IDesignProjectId.BenchLong]: {
                    value : undefined,
                    min   : 0,
                    max   : 50,
                },
            },
            [IDesignProjectCategoryId.ShowCaseLight]: {
                [IDesignProjectId.ShowCaseLight]: {
                    value : undefined,
                    min   : 0,
                    max   : 20,
                },
            },
            [IDesignProjectCategoryId.Teaches]: {
                [IDesignProjectId.WoodenSign]: {
                    value : undefined,
                    min   : 0,
                    max   : 10,
                },
                [IDesignProjectId.MetalSign]: {
                    value : undefined,
                    min   : 0,
                    max   : 10,
                },
                [IDesignProjectId.NeonSign]: {
                    value : undefined,
                    min   : 0,
                    max   : 10,
                },
            },
            [IDesignProjectCategoryId.LightsAndDeco]: {
                [IDesignProjectId.Mirror]: {
                    value : undefined,
                    min   : 0,
                    max   : 50,
                },
                [IDesignProjectId.LEDStrip]: {
                    value : undefined,
                    min   : 0,
                    max   : 50,
                },
                [IDesignProjectId.RecessedSpot]: {
                    value : undefined,
                    min   : 0,
                    max   : 50,
                },
                [IDesignProjectId.CeilingLight]: {
                    value : undefined,
                    min   : 0,
                    max   : 50,
                },
                [IDesignProjectId.StreetLamp]: {
                    value : undefined,
                    min   : 0,
                    max   : 50,
                },
                [IDesignProjectId.GreenWall]: {
                    value : undefined,
                    min   : 0,
                    max   : 50,
                },
            },
            [IDesignProjectCategoryId.Ground]: {
                [IDesignProjectId.TiledFloor]: {
                    value : undefined,
                    min   : 0,
                    max   : 1000,
                },
                [IDesignProjectId.WaxedConcreteFloor]: {
                    value : undefined,
                    min   : 0,
                    max   : 1000,
                },
                [IDesignProjectId.ParquetFloor]: {
                    value : undefined,
                    min   : 0,
                    max   : 1000,
                },
            },
        },
        additionalData: additionalDataFactory({
            budgetMin          : 2000,
            budgetMax          : 250000,
            budgetDefaultValue : 15000,
            marks              : budgetMarksBuilder(2000, 1000, 50000, 5000, 250000),
            hasQuantity        : false,
        }),
        contact: fieldsContact,
    },
};

export default dpBeautyInstituteForm;
